import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { Table, TableModule } from "primeng/table";
import { OrderNotes } from "../../../core/models/invoice-preview/orderNotes";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ActivatedRoute } from "@angular/router";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { SalesOrderNotes } from "../../../core/models/orders/salesOrderNotes";
import { InvoicePreviewSummaryService } from "../../../core/services/invoice-preview-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderNotesSidebarService } from "../../../core/services/order-notes-sidebar.service";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { HidedynamicsdatePipe } from "../../../shared/pipes/hidedate/hidedynamicsdate.pipe";

@UntilDestroy()
@Component({
  selector: "jni-invoice-preview-order-notes",
  templateUrl: "./invoice-preview-order-notes.component.html",
  styleUrls: ["./invoice-preview-order-notes.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    SelectModule,
    FormsModule,
    HidedynamicsdatePipe,
  ],
})
export class InvoicePreviewOrderNotesComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() saleOrderId = "";
  @Input() isFromInvoiceSummary = false;
  @Output() selectedOrderNotesListing = new EventEmitter<OrderNotes[]>();
  @Output() scrollHiddenStatus = new EventEmitter();
  @Input() orderNotesGridListing: OrderNotes[] = [];

  @ViewChild("dt") table!: Table;

  purchaseOrderNumber: string[] = [];
  selectedOrderNotesGridListing: OrderNotes[] = [];
  orderNotesModalStatus = false;
  typeList = [
    {
      id: 1,
      name: "Billing note",
    },
    {
      id: 2,
      name: "Collections",
    },
    // 11286 - PGL-270 Remove Invoice Note option From All Note Forms
    // {
    //   id: 3,
    //   name: 'Invoice note'
    // },
    {
      id: 4,
      name: "Order note",
    },
  ];

  constructor(
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private router: ActivatedRoute,
    private _orderNotesSidebarService: OrderNotesSidebarService,
    private _invoicePreviewSummaryService: InvoicePreviewSummaryService
  ) {
    this.router.params.subscribe(params => {
      this.saleOrderId = params["id"];
    });
  }

  ngOnInit(): void {
    if (this.saleOrderId) {
      this.orderNotesModalStatus = true;
      this.getSalesOrderNotes(this.saleOrderId);
      // this.getAllLinePoNumber(this.saleOrderId);
    }
  }

  ngOnChanges() {
    if (this.saleOrderId) {
      //this.ngOnInit();
      //this.getAllLinePoNumber(this.saleOrderId);
    }
  }

  getSalesOrderNotes(saleOrderId: string) {
    if (saleOrderId) {
      this._invoicePreviewSummaryService
        .getSalesOrderNotes(saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.selectedOrderNotesGridListing = [];
            if (res.data) {
              this.orderNotesGridListing = res.data;
            }
          },
          error: res => {
            this._toastr.error("Error", res.message || "Order note not found");
          },
        });
    }
  }

  getAllLinePoNumber(saleOrderId: string) {
    if (saleOrderId) {
      this._orderNotesSidebarService
        .getAllLinePoNumber(saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.purchaseOrderNumber = res.data;
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  onEditRow(orderNotesGridListing: SalesOrderNotes) {
    this.cancelAllEditRow();
    const row = this.table.value.filter(x => x.id === orderNotesGridListing.id);
    if (row.length > 0) {
      this.table.initRowEdit(row[0]);
    }
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  onRowEditSave(orderNotesGridListing: SalesOrderNotes) {
    this.cancelAllEditRow();
    if (!orderNotesGridListing.type) {
      this._toastr.error("Error", "Type is required");
      this.getSalesOrderNotes(this.saleOrderId);
      return;
    }
    if (!orderNotesGridListing.description) {
      this._toastr.error("Error", "Description is required");
      this.getSalesOrderNotes(this.saleOrderId);
      return;
    }

    if (
      (orderNotesGridListing?.type === "Billing note" ||
        orderNotesGridListing?.type === "Order note") &&
      !orderNotesGridListing?.purchaseOrderId
    ) {
      this._toastr.error("Error", "Purchase Order is required");
      this.getSalesOrderNotes(this.saleOrderId);
      return;
    }

    this._loaderService.setLoaderState(true);
    this._orderNotesSidebarService
      .AddSalesOrderNotes(orderNotesGridListing)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.getSalesOrderNotes(this.saleOrderId);
            this._toastr.success(
              "Success",
              res.message || "Order note update successfully"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error updating order note"
          );
        },
      });
  }

  updateSingleLine() {
    if (this.selectedOrderNotesGridListing.length === 1) {
      this.selectedOrderNotesListing.emit(this.selectedOrderNotesGridListing);
    }
  }

  deleteSaleOrderNotes() {
    const array: number[] = [];
    if (this.selectedOrderNotesGridListing.length > 0) {
      this.selectedOrderNotesGridListing.forEach(x => {
        array.push(x.id);
      });
      this._loaderService.setLoaderState(true);
      this._orderNotesSidebarService
        .deleteSalesOrderNotes(array)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this.getSalesOrderNotes(this.saleOrderId);
              this.selectedOrderNotesGridListing = [];
              if (res?.status?.toLowerCase() === "success") {
                this._toastr.success(
                  "Success",
                  res.message || "Order note delete successfully"
                );
              } else {
                this._toastr.error(
                  "Error",
                  res.message || "Error deleting order note"
                );
              }
            } else {
              if (res?.status?.toLowerCase() !== "success") {
                this._toastr.error(
                  "Error",
                  res.message || "Error deleting order note"
                );
              }
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  disabledField(type: string) {
    if (type === "Billing note") {
      return false;
    } else if (type === "Order note") {
      return false;
    } else {
      return true;
    }
  }

  onPurchaseorderstatus = false;
  onPurchaseorderchange(type: string, id: number) {
    if (type === "Billing note") {
      this.onPurchaseorderstatus = false;
    } else if (type === "Order note") {
      this.onPurchaseorderstatus = false;
    } else {
      this.onPurchaseorderstatus = true;
      const lineObject = this.orderNotesGridListing?.find(x => x?.id === id);
      if (lineObject) {
        if (lineObject?.purchaseOrderId) {
          lineObject.purchaseOrderId = "";
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }
}
